import { Input } from 'component/Input'
import { Space } from 'component/Space'
import { useLatestCallback } from 'hook/useLatestCallback'
import { observer } from 'mobx-react-lite'
import { FilterStore } from 'page/catalog/store/FilterStore'

type Props = {
  filter: FilterStore
}

export const SearchPane = observer(({ filter }: Props) => {
  const setSearch = useLatestCallback((value: string) => {
    filter.search = value
  })

  return <Space pad={[0, 8, 12, 8]}>
    <Input value={filter.search} onChange={setSearch} />
  </Space>
})
